import URL from '../url'
import Request from '../request'

/**
 *
 */
export const shopGetService = () => new Request(URL.API, URL.GET_SHOP).get()

/**
 *
 * @param {*} entity
 */
export const shopEditService = entity =>
  new Request(URL.API, URL.EDIT_SHOP).put(entity)

/**
 *
 * @param {*} content
 */
export const shopPatchService = content =>
  new Request(URL.API, URL.PATCH_SHOP + '?id=' + content.id).patch(content)

/**
 * Done state of the Home setup steps for the current workspace.
 * @returns {Promise<{ data: { branding: boolean, portal: boolean, firstCourse: boolean, connectAi: boolean } }>}
 */
export const shopSetupStatusService = () =>
  new Request(URL.API, URL.SHOP_SETUP_STATUS).get()

/**
 * Workspace branding (logo, favicon, primaryColor, font, customCss, customJs).
 */
export const shopBrandingGetService = () =>
  new Request(URL.API, URL.SHOP_BRANDING).get()

/**
 * Saves logo, favicon, primaryColor and font. Send the whole set; null clears.
 * @param {{ logo, favicon, primaryColor, font }} branding
 */
export const shopBrandingUpdateService = branding =>
  new Request(URL.API, URL.SHOP_BRANDING).put(branding)

/**
 * Saves the workspace custom code injected into every course and landing page.
 * @param {{ css: string, js: string }} code
 */
export const shopCustomCodeUpdateService = code =>
  new Request(URL.API, URL.SHOP_BRANDING_CUSTOM_CODE).put(code)

/**
 * Workspace language (Workspace › Language).
 * @returns {Promise<{ data: { languageCode: string } }>}
 */
export const shopLanguageGetService = () =>
  new Request(URL.API, URL.SHOP_LANGUAGE).get()

/**
 * @param {string} languageCode
 */
export const shopLanguageUpdateService = languageCode =>
  new Request(URL.API, URL.SHOP_LANGUAGE).put({ languageCode })

/**
 * Built-in texts of a language with the workspace's edits.
 * @returns {Promise<{ data: { languageCode, groups: [{ code, label, texts: [{ key, label, defaultText, text }] }] } }>}
 */
export const shopTextsGetService = languageCode =>
  new Request(
    URL.API,
    URL.SHOP_LANGUAGE_TEXTS.replace('{languageCode}', languageCode),
  ).get()

/**
 * Saves changed texts of a language; null resets a text to its default.
 * @param {string} languageCode
 * @param {{ [key: string]: string | null }} texts
 */
export const shopTextsUpdateService = (languageCode, texts) =>
  new Request(
    URL.API,
    URL.SHOP_LANGUAGE_TEXTS.replace('{languageCode}', languageCode),
  ).put({ texts })
